import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingVisitType,
    deleteVisitType,
    saveOrUpdateVisitType,
    getVisitTypeById
} from 'app/services/VisitTypeService';

import { VisitType } from "app/common/Model/VisitType";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { PAGESIZE_ALL } from "app/common/LocalConst";

export default class VisitTypeStore {
    listAllVisitType = [];
    searchVisitType = new SearchObject();
    pageVisitType = null;
    selectedVisitType = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteVisitType = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllVisitType = async () => {
        if (this.listAllVisitType?.length === 0) {
            await pagingVisitType({ pageIndex: 1, pageSize: PAGESIZE_ALL }).then(({ data }) => {
                this.listAllVisitType = data?.content;
            })
        }
    }

    pagingVisitType = () => {
        pagingVisitType(this.searchVisitType).then(({ data }) => {
            this.pageVisitType = data;
        })
    }

    handleChangeFormSearch = (searchVisitType) => {
        this.searchVisitType = checkSearchObject(this.searchVisitType, searchVisitType);
        this.pagingVisitType();
    }

    handleOpenFormCreateOrEdit = (visitTypeId) => {
        if (Boolean(visitTypeId)) {
            getVisitTypeById(visitTypeId).then(({ data }) => {
                this.selectedVisitType = data;
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                console.error(error);
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedVisitType = new VisitType();
            this.openFormCreateOrEdit = true;
        }
    }

    saveVisitType = (visitType, { setSubmitting }) => {
        saveOrUpdateVisitType(visitType).then(() => {
            this.selectedVisitType = null;
            toast.success("Lưu kiểu thăm khám thành công!");
            this.pagingVisitType();
            this.handleClosePopup();
            this.listAllVisitType = [];
        }).catch(function (error) {
            console.error(error);
            toast.error("Lưu kiểu thăm khám thất bại!");
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteVisitType = (visitType) => {
        this.selectedVisitType = { id: visitType?.id };
        this.openConfirmDeleteVisitType = true;
    }

    handleConfirmDeleteVisitType = () => deleteVisitType(this.selectedVisitType?.id)
        .then(() => {
            if (this.searchVisitType?.pageIndex > 1 && this.pageVisitType?.content?.length === 1) {
                this.searchVisitType.pageIndex -= 1;
            }
            toast.success("Xóa kiểu thăm khám thành công!");
            this.pagingVisitType();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa kiểu thăm khám thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteVisitType = false;
    }

    resetStore = () => {
        this.searchVisitType = new SearchObject();
        this.pageVisitType = null;
        this.selectedVisitType = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteVisitType = false;
    }
}